import {IconButton, TextField, Tooltip} from '@material-ui/core';
import {
  AddCircleOutline as AddIcon,
  AssignmentReturnOutlined as AssignmentReturnOutlinedIcon,
  Edit as EditIcon,
} from '@material-ui/icons';
import Axios from 'axios';
import MaterialTable from 'material-table';
import React, {Fragment, useEffect, useState} from 'react';
import PopupForm from '../utils/PopupForm';
import {tableIcons} from '../../styles/tableIcons';
import {tableLocalization} from '../../styles/tableLocalization';
import AddTeacherClassroomForm from '../AddTeacherClassroomForm';
import TeacherUpdateClassroomForm from '../TeacherUpdateClassroomForm';
import TableTitle from '../utils/TableTitle';

export function TeacherClassroomsTable({user}) {
  const [classrooms, setClassrooms] = useState([]);
  const [classroom, setClassroom] = useState({});
  const [openDialog, setOpenDialog] = useState(null);
  const closeDialog = () => setOpenDialog(null);

  const columns = [
    {title: 'Name', field: 'name'},
    {
      title: 'Student Signup Link',
      field: 'signupCode',
      render: (rowData) => {
        const baseUri = document.baseURI.split('/').slice(0, 3).join('/');
        const signupCode = rowData.signupCode ? rowData.signupCode : '';
        const classroomSignupLink = `${baseUri}/${user.provider}/${signupCode}`;
        return (
          <Fragment>
            <TextField
              id={`classroom-signup-link-${rowData._id}`}
              size="small"
              disabled
              name="signupCode"
              label="Copy and share"
              variant="outlined"
              value={classroomSignupLink}
            />
            <Tooltip title="Copy signup link">
              <IconButton
                aria-label="Copy signup link"
                onClick={() =>
                  navigator.clipboard.writeText(classroomSignupLink)
                }
              >
                <AssignmentReturnOutlinedIcon style={{color: '#19cccc'}} />
              </IconButton>
            </Tooltip>
          </Fragment>
        );
      },
    },
    {
      title: 'Archived',
      field: 'isArchived',
      type: 'boolean',
      initialEditValue: false,
      emptyValue: false,
    },
  ];

  useEffect(() => {
    const getClassrooms = async () => {
      const result = await Axios.get('/api/user/me/classrooms?show=all');

      setClassrooms(result.data);
    };
    getClassrooms();
  }, []);

  return (
    <>
      <MaterialTable
        localization={tableLocalization}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Create Classroom',
            isFreeAction: true,
            onClick: () => setOpenDialog('add'),
          },
          {
            icon: () => <EditIcon />,
            tooltip: 'Update Classroom',
            onClick: (event, rowData) => {
              setClassroom(rowData);
              setOpenDialog('update');
            },
          },
        ]}
        options={{
          // Column drag handles render a role="button" inside each sortable
          // header button (nested interactive controls, WCAG 4.1.2).
          draggable: false,
          actionsColumnIndex: -1,
        }}
        title={<TableTitle>{'Classrooms'}</TableTitle>}
        columns={columns}
        data={classrooms}
        icons={tableIcons}
      />
      <PopupForm
        component={AddTeacherClassroomForm}
        title="Add Classroom"
        user={user}
        open={openDialog === 'add'}
        onClose={closeDialog}
      />
      <PopupForm
        component={TeacherUpdateClassroomForm}
        classroom={classroom}
        title="Update Classroom"
        open={openDialog === 'update'}
        onClose={closeDialog}
      />
    </>
  );
}
